module.exports = __webpack_public_path__ + "img/equity.0fa9b623.png";